<template>
  <div class="rs-lazy-load">
    <div class="solicitacao-header m-b-xl">
      <h1 class="title is-h1 lazy" />
    </div>
    <div class="solicitacao-content m-b-xl">
      <h2 class="subtitle is-h2 lazy" />
      <div class="columns">
        <div class="info-box column">
          <p class="info-label subtitle is-6 lazy" />
          <p class="info-text title is-4 lazy" />
        </div>
        <div class="info-box column">
          <p class="info-label subtitle is-6 lazy" />
          <p class="info-text title is-4 lazy" />
        </div>
      </div>
      <div class="columns">
        <div class="info-box column">
          <p class="info-label subtitle is-6 subtitle is-6 lazy" />
          <p class="info-text title is-4 lazy" />
          <p class="text lazy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RsLazyLoad'
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
.rs-lazy-load {
  @keyframes gradientBG {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: -200% 50%;
    }
    100% {
      background-position: -400% 50%;
    }
  }

  .lazy {
    display: block;
    margin-bottom: 2rem;

    background: linear-gradient(
      90deg,
      $gray-200 0%,
      $gray-200 50%,
      $gray-300 75%,
      $gray-200 90%,
      $gray-200 100%
    );
    background-size: 200% 100%;
    animation: gradientBG 3s ease-in-out infinite;

    &.title {
      height: 2em;
      width: 90%;
    }

    &.subtitle {
      height: 1.8em;
      width: 75%;
    }

    &.description {
      height: 1em;
      width: 100%;
    }

    &.text {
      height: 10em;
      width: 100%;
    }
  }
}
</style>
